import { render, staticRenderFns } from "./AdminSandpitVisibilitySelector.vue?vue&type=template&id=b9477a04&scoped=true&"
import script from "./AdminSandpitVisibilitySelector.vue?vue&type=script&lang=ts&"
export * from "./AdminSandpitVisibilitySelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9477a04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtn,VBtnToggle})
